import { TableSection, TopSection } from '@/features/notifications';

export function NotificationsPage() {
  return <TableSection />;
}
